<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12 common_title">
       <h2>EDIT - SPECIES MANAGEMENT</h2>
       <!--<a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
        Back
       </a>-->
      </div>
       <div class="col-lg-6 col-md-6 col-sm-6 common_title">
        <p>Edit Species record</p>
       </div>
      </div>
       <form [formGroup]="registerForm"  class="row bottomheight">
              <!--loader start-->
  <div class="loading-div" *ngIf="isLoading">
    <div class="loading-bar">
        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        <p class="mt-3">Processing data. Please wait..</p>
    </div>
  </div>
    <!--loader end-->
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group multiple">
          <label for="Farm Name" class="farmmulti" >Farm Name</label>
          <select  multiple="multiple" name="farmname" id="farmname"  class="form-control">
            <!--<option *ngFor='let getfarms of getfarmsListData' [value]="getfarms.tnfr_id">{{getfarms.tnfr_name}}</option>
            -->
                <ng-container  *ngFor='let getfarms of getfarmsListData'> 
                  <ng-container  *ngFor='let farmload of speciesloadid'> 
              <option *ngIf="(getfarms.tnfr_id==farmload.farmloadid && getfarms.can_delete!='0')" [value]="getfarms.tnfr_id" [class.my_class]="(getfarms.tnfr_id==farmload.farmloadid)" selected >{{getfarms.tnfr_name}}</option>
              <option *ngIf="(getfarms.tnfr_id==farmload.farmloadid && getfarms.can_delete=='0');let else loggedOut" [value]="getfarms.tnfr_id" selected >{{getfarms.tnfr_name}}</option>
              <ng-container *ngIf="resultcond==1">
                <option *ngIf="(getfarms.tnfr_id!=farmload.farmloadid)" [value]="getfarms.tnfr_id">{{getfarms.tnfr_name}}</option>
                </ng-container>
            </ng-container> 
            <ng-container *ngIf="resultcond>1">
              <option  [value]="getfarms.tnfr_id">{{getfarms.tnfr_name}}</option>
              </ng-container>
               </ng-container> 
          </select>
          </div>
          </div>
       <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="form-group ">
          <label for="Species Name">Species Name</label>
          <input type="text" name="adddose" id="speciesEditName" value="" class="form-control">
          </div>
       </div>
       <div class="col-lg-3 col-md-6 col-sm-6">
       <div class="form-group common_title">
        <label for="Species ID" >Species ID</label>
        <input type="text" name="adddose" id="speciesEditId" value="" class="form-control">
        </div>
       </div>
       <div class="col-lg-2 col-md-6 col-sm-6" style="top: -28px;">
       <div class="form-group">
       <label for="Status"><span class="dec">Status</span></label>
       <select  name="speciesEditStatus" id="speciesEditStatus" class="selectpicker form-control speciesfake" (change)="editstatusvalue()">
        <option value="1">Active</option>
        <option value="0">Inactive</option>
       </select>
       </div>
       </div>
       <div class="row">

        <div class="col-lg-12 col-md-12 col-sm-12 text-center" style="top:-26px;
        left: 267px;">

        <div class="col-lg-2 col-md-2 col-sm-2 text-center">
          </div>
          <div class="col-lg-8 col-md-8 col-sm-8 text-center">
         
       <table class="table" style="color: white;border:none;font-family: 'Montserrat', sans-serif;">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col" class="sizered">Name</th>
              <th scope="col" class="sizered">Lower Limit (Days)</th>
              <th scope="col" class="sizered">Upper Limit (Days)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th><span class="sizered">Age Group 1</span></th>
              <td>                  
                <input type="text" name="agegroupName1" id="agegroupName1"  value="" class="form-control">
                
              </td>
                  <td>                  
                <input type="text" name="lowerlimit1" id="lowerlimit1"  value="" class="form-control" readonly>
                
                  </td>
                  <td>                  
                <input type="text"  name="upperlimit1" id="upperlimit1"  (keyup)="getinputvalue($event)" value="" class="form-control">      
              </td>
              </tr>
              <tr>
                <th><span class="sizered">Age Group 2</span></th>
                <td>    
                            
                  <input type="text" name="agegroupName2" id="agegroupName2"  class="form-control" >
                </td>
                    <td>                  
                  <input type="text" name="lowerlimit2" id="lowerlimit2"  [value]="upperlimit" class="form-control" readonly>
                  
                    </td>
                    <td>                  
                  <input type="text" name="upperlimit2" id="upperlimit2"  (keyup)="getinputvalue2($event)" value="" class="form-control">
                  
                    </td>
                </tr>
                <tr>
                  <th><span class="sizered">Age Group 3</span></th>
                  <td>                  
                    <input type="text" name="agegroupName3" id="agegroupName3"  value="" class="form-control">
                    
                  </td>
                      <td>                  
                    <input type="text" name="lowerlimit3" id="lowerlimit3"  [value]="upperlimit1" class="form-control" readonly>
                    
                      </td>
                      <td>                  
                    <input type="text" name="upperlimit3" id="upperlimit3" (keyup)="getinputvalue3($event)" value="" class="form-control">
                      </td>
               
                  </tr>

                
                  <tr *ngIf="agegroupname4==4">
                    <th><span class="sizered">Age Group 4</span></th>
                    <td>                  
                      <input type="text" name="agegroupName4" id="agegroupName4"  value="" class="form-control">
                      
                    </td>
                        <td>                  
                      <input type="text" name="lowerlimit4" id="lowerlimit4"  [value]="upperlimit2" class="form-control" readonly>
                      
                        </td>
                        <td>                  
                      <input type="text" name="upperlimit4" id="upperlimit4"  value="" class="form-control">
                        </td>
                    </tr>
           
          </tbody>
        </table>
      </div>
        <div class="col-lg-2 col-md-2 col-sm-2 text-center">
        </div>
      </div>
       </div>

       <div class="col-lg-12 col-md-12 col-sm-12 text-center">
       <a (click)="speciesmanagement()" class="btn btn-fill btn-primary mb-3" >Submit<div class="ripple-container"></div></a>
       <button (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div></button>
       </div>

       </form>
     </div>
   </div>
 </div>
 
<!-- The Modal -->
<!--<div class="modal bd-example-modal-lg"  id="myModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">


      <div class="modal-header">
        <h4 class="modal-title">Age group</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

     
      <div class="modal-body">
        <form class="row">
          <div *ngFor="let agegroup of arrayval">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12">
            <div class="form-group">
              <label for="Species Name" class="puptext" >Age Group Name</label>
              <input type="text" name="Name_{{agegroup.tnag_id}}" id="Name_{{agegroup.tnag_id}}"   value="{{agegroup.tnag_name}}" class="form-control">
              </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12">
              <div class="form-group">
                <label for="Species Name" class="puptext" >Time Range(In days)</label>
                <input type="text" name="timerange_{{agegroup.tnag_id}}" id="timerange_{{agegroup.tnag_id}}"  value="{{agegroup.time_range}}" class="form-control">
                </div>
                </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="form-group" style="margin-top:-11px;">
                  <label for="Status"  class="puptext">Status</label>
                  <select id="statusage_{{agegroup.tnag_id}}" name="statusage_{{agegroup.tnag_id}}" class="selectpicker form-control" value="{{agegroup.tnag_status}}">
                  <option class="green" value="0">Active</option>
                  <option  class="red" value="1">InActive</option>
                  </select>
                </div>
                      </div>
              </div>
                </div>
         <div class="col-lg-12 col-md-12 col-sm-12 text-center">
          <button data-dismiss="modal"  (click)="modelpopupgetdata()" type="submit" class="btn btn-fill btn-primary mb-3" >Submit<div class="ripple-container"></div></button>
          <button data-dismiss="modal"  (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div></button>
          </div>
         </form>
        </div>

    </div>
  </div>
</div>-->

